import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Box,
    Button,
    Stack,
} from '@mui/material';
import RequestService from '../../services/RequestService';
import { ReactComponent as CoinIcon } from '../../assets/icons/coin.svg';
import { ReactComponent as XpIcon } from '../../assets/icons/xp.svg';
import RewardBadge from '../RewardBadge';
import ReviewProveCarouselDialog from './ReviewProveCarousselDialog';
import RejectReasonDialog from './RejectReasonDialog';

const UserContentReviewDialog = ({
    open,
    onSucessApprove,
    onClose,
    content,
}) => {
    const { title, description, xp, coin, userContents = [] } = content || {};

    const [isCarouselOpen, setIsCarouselOpen] = useState(false);
    const [currentProofs, setCurrentProofs] = useState([]);
    const [rejectOpen, setRejectOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedUC, setSelectedUC] = useState(null);

    const handleOpenCarousel = (proofs) => {
        setCurrentProofs(proofs);
        setIsCarouselOpen(true);
    };

    const handleCloseCarousel = () => {
        setIsCarouselOpen(false);
        setCurrentProofs([]);
    };

    const approve = async (uc) => {
        if (!uc) return;
        try {
            setLoading(true);
            await RequestService.reviewUserContent(uc.userContentId, {
                approved: true,
            });
            onSucessApprove('Conteúdo aprovado com sucesso!');
            onClose();
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const openReject = (uc) => {
        setSelectedUC(uc);
        setRejectOpen(true);
    };
    const closeReject = () => setRejectOpen(false);

    const confirmReject = async (reason, note) => {
        if (!selectedUC) return;
        try {
            setLoading(true);
            await RequestService.reviewUserContent(selectedUC.userContentId, {
                approved: false,
                rejectionReason: reason,
                rejectionNote: note,
            });
            onSucessApprove('Conteúdo rejeitado com sucesso!');
            onClose();
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
            closeReject();
            setSelectedUC(null);
        }
    };

    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
                <DialogTitle
                    sx={{
                        fontFamily: 'Poppins',
                        fontSize: '20px',
                        color: '#292929',
                        fontWeight: '400',
                    }}
                >
                    Revisar Missão
                </DialogTitle>
                <DialogContent>
                    <Box
                        sx={{
                            backgroundColor: '#EDF8FF',
                            padding: 3,
                            borderRadius: '10px',
                            marginBottom: '24px',
                        }}
                    >
                        <Typography
                            sx={{
                                fontFamily: 'Poppins',
                                fontSize: '16px',
                                fontWeight: '400',
                                color: '#292929',
                            }}
                        >
                            {title} 🍀
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                fontFamily: 'Poppins',
                                fontSize: '14px',
                                fontWeight: '400',
                                color: '#292929',
                            }}
                        >
                            {description}
                        </Typography>
                        <Stack direction="row" spacing={3} sx={{ mt: 3 }}>
                            <RewardBadge
                                icon={
                                    <CoinIcon
                                        style={{
                                            color: '#134F99',
                                            fontSize: '24px',
                                        }}
                                    />
                                }
                                value={coin}
                            />
                            <RewardBadge
                                icon={
                                    <XpIcon
                                        style={{
                                            color: '#134F99',
                                            fontSize: '24px',
                                        }}
                                    />
                                }
                                value={xp}
                            />
                        </Stack>
                    </Box>

                    <Typography
                        variant="h6"
                        sx={{
                            mb: 2,
                            fontFamily: 'Poppins',
                            fontSize: '20px',
                            color: '#292929',
                            fontWeight: '400',
                        }}
                    >
                        Solicitações
                    </Typography>
                    <Box>
                        {userContents.length > 0 ? (
                            userContents.map((userContent) => (
                                <Box
                                    key={userContent.userContentId}
                                    sx={{
                                        backgroundColor: '#EDF8FF',
                                        padding: 3,
                                        borderRadius: '10px',
                                        marginBottom: '16px',
                                    }}
                                >
                                    <Stack direction="row" spacing={2}>
                                        <Stack
                                            sx={{
                                                flex: 2,
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontFamily: 'Poppins',
                                                    fontSize: '16px',
                                                    color: '#292929',
                                                    fontWeight: '400',
                                                }}
                                            >
                                                Jogador
                                            </Typography>
                                            <Typography
                                                sx={{
                                                    fontFamily: 'Poppins',
                                                    fontSize: '14px',
                                                    color: '#292929',
                                                    fontWeight: '400',
                                                }}
                                            >
                                                {userContent.user.name}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    fontFamily: 'Poppins',
                                                    fontSize: '12px',
                                                    color: '#6B6B6B',
                                                }}
                                            >
                                                {userContent.user.email}
                                            </Typography>
                                        </Stack>

                                        <Stack
                                            sx={{
                                                flex: 2,
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontFamily: 'Poppins',
                                                    fontSize: '16px',
                                                    color: '#292929',
                                                    fontWeight: '400',
                                                }}
                                            >
                                                Comentário
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    mt: 1,
                                                    fontFamily: 'Poppins',
                                                    fontSize: '14px',
                                                    color: '#292929',
                                                }}
                                            >
                                                {userContent.description ||
                                                    'Sem comentário.'}
                                            </Typography>
                                        </Stack>

                                        <Stack
                                            sx={{
                                                flex: 2,
                                                alignItems: 'center',
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontFamily: 'Poppins',
                                                    fontSize: '16px',
                                                    color: '#292929',
                                                    fontWeight: '400',
                                                }}
                                            >
                                                Arquivos
                                            </Typography>
                                            <Button
                                                variant="text"
                                                color="primary"
                                                sx={{
                                                    mt: 1,
                                                }}
                                                onClick={() =>
                                                    handleOpenCarousel(
                                                        userContent.proveSignedUrls
                                                    )
                                                }
                                            >
                                                Visualizar
                                            </Button>
                                        </Stack>

                                        <Stack
                                            sx={{
                                                flex: 1,
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontFamily: 'Poppins',
                                                    fontSize: '16px',
                                                    color: '#292929',
                                                    fontWeight: '400',
                                                }}
                                            >
                                                Ação
                                            </Typography>
                                            <Stack
                                                direction="row"
                                                spacing={2}
                                                justifyContent="flex-end"
                                                sx={{ mt: 2 }}
                                            >
                                                <Button
                                                    variant="contained"
                                                    color="error"
                                                    disabled={loading}
                                                    onClick={() =>
                                                        openReject(userContent)
                                                    }
                                                >
                                                    Reprovar
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    disabled={loading}
                                                    onClick={() =>
                                                        approve(userContent)
                                                    }
                                                >
                                                    Aprovar
                                                </Button>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                </Box>
                            ))
                        ) : (
                            <Typography
                                variant="body2"
                                sx={{
                                    textAlign: 'center',
                                    color: 'gray',
                                    fontFamily: 'Poppins',
                                }}
                            >
                                Nenhuma solicitação pendente.
                            </Typography>
                        )}
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button onClick={onClose} variant="outlined">
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>

            <RejectReasonDialog
                open={rejectOpen}
                onClose={closeReject}
                onConfirm={confirmReject}
            />

            <ReviewProveCarouselDialog
                open={isCarouselOpen}
                onClose={handleCloseCarousel}
                proofs={currentProofs}
            />
        </>
    );
};

export default UserContentReviewDialog;
